module.exports = __webpack_public_path__ + "static/media/product_13.ba393bb5.jpg";